module.exports = __webpack_public_path__ + "media/images/thumbs/muscles/ahand10-cf8f62cdc46b001a80021429763af927.jpg";